import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	titleFade: {
		// eslint-disable-next-line jira/i18n/id-named-by-package -- PLEASE FIX THIS SUPPRESSION
		id: 'issue-create.modal.modal-wrapper.minimizable-modal-modal.header.title',
		defaultMessage: 'Create',
		description: 'Title for issue create modal',
	},
	title: {
		// eslint-disable-next-line jira/i18n/id-named-by-package -- PLEASE FIX THIS SUPPRESSION
		id: 'issue-create.modal.modal-wrapper.minimizable-modal-modal.header.title-to-be-faded',
		defaultMessage: 'Create issue',
		description: 'Title for issue create modal before the terminology refresh',
	},
	subtaskTitle: {
		id: 'issue-create.modal.modal-wrapper.minimizable-modal-modal.header.subtask-title',
		defaultMessage: 'Create subtask',
		description: 'Title for subtask create modal',
	},
	createLinkedIssueDialogTitle: {
		id: 'issue-create.modal.modal-wrapper.minimizable-modal-modal.header.create-linked-issue-dialog-title',
		defaultMessage: 'Create linked issue',
		description: 'Title of the create linked issue dialog.',
	},
	changerButtonsDisabledForgeFields: {
		id: 'issue-create.modal.modal-wrapper.minimizable-modal-modal.header.changer-buttons-disabled-forge-fields',
		defaultMessage: 'Some fields in this project and issue type don’t allow resizing or minimizing',
		description:
			'The tooltip when the changer buttons on the GIC are disabled when forge fields or ui modifications are detected',
	},
});
